import { getSetting } from "@/api/options";
import titleController from '@/util/titleController'
export default {
  namespaced: true,
  state:{
    loading: true,
    data: {}
  },
  mutations:{
    SET_LOADING(state, payload){
      state.loading = payload;
    },
    SET_DATA(state, payload){
      state.data = payload
    },
  },
  actions: {
    async fetchOptions(ctx){
      ctx.commit('SET_LOADING', true);
      const res = await getSetting()
      ctx.commit('SET_DATA', res)
      ctx.commit('SET_LOADING', false)
      if(res.favicon){
        let link = document.querySelector('link[ref="shortcut icon"]');
        if(link) return;
        link = document.createElement('link')
        link.rel = 'shortcut icon';
        link.type = 'images/x-icon';
        link.href = res.favicon;
        document.querySelector('head').appendChild(link)
      }
      if(res.siteTitle) titleController.setSiteTitle(res.siteTitle)
    }
  }
}